import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
var ModalWizardStep = function ModalWizardStep(param) {
    var children = param.children, _param_showProgressBar = param.showProgressBar, showProgressBar = _param_showProgressBar === void 0 ? true : _param_showProgressBar, _param_countsAsProgress = param.countsAsProgress, countsAsProgress = _param_countsAsProgress === void 0 ? true : _param_countsAsProgress;
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: children
    });
};
export { ModalWizardStep };

//# sourceMappingURL=ModalWizardStep.js.map